'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scroll = void 0;
const $ = require("jquery");
class Scroll {
    constructor() {
        $(window).on('load scroll', () => {
            // ヘッダーロゴサイズ変更
            if ($('.bulletHeaderLogo').length) {
                const scrollPosition = $(window).scrollTop();
                if (scrollPosition > 100) {
                    $('.bulletHeader').attr('data-is-scroll', 'true');
                    $('.bulletHeaderLogo').attr('data-is-scroll', 'true');
                }
                else {
                    $('.bulletHeader').attr('data-is-scroll', 'false');
                    $('.bulletHeaderLogo').attr('data-is-scroll', 'false');
                }
                // スマホのメニュー（検索・受験生応援サイト・アクセス）開閉
                this.scrollChangeHeaderNavies(scrollPosition);
            }
        });
    }
    //
    scrollChangeHeaderNavies(scrollPosition) {
        const SP_SIZE = 800;
        const browserWidth = $(window).outerWidth();
        if (SP_SIZE >= browserWidth) {
            if (scrollPosition > 100) {
                $('.bulletHeaderNavi').slideUp(500);
            }
            else {
                $('.bulletHeaderNavi').slideDown(500);
            }
        }
    }
}
exports.Scroll = Scroll;
exports.default = Scroll;
